import { QuoteSideTypeEnum, SpotTypesMapper } from "../..";
export const priceErrorMapper = {
  unknown: { start: 'Unknown error' },
  sideNotDefined: { start: 'Trade side is not defined' },
  priceNotDefined: { start: 'Enter a price to trade' },
  limitPriceMustBeAbove: {
    start: 'Limit price must be ',
    emphasized: 'above',
    end: ' the market rate.',
  },
  limitPriceFirstLegMustBeAbove: {
    start: 'Sell Limit Order, Limit price must be ',
    emphasized: 'above',
    end: ' the market rate.',
  },
  limitPriceSecondLegMustBeAbove: {
    start: 'Sell Limit Loss, Limit price must be ',
    emphasized: 'above',
    end: ' the market rate.',
  },
  limitPriceMustBeBelow: {
    start: 'Limit price must be ',
    emphasized: 'below',
    end: ' the market rate.',
  },
  limitPriceFirstLegMustBeBelow: {
    start: 'Buy Limit Order, Limit price must be ',
    emphasized: 'below',
    end: ' the market rate.',
  },
  limitPriceSecondLegMustBeBelow: {
    start: 'Buy Limit Loss, Limit price must be ',
    emphasized: 'below',
    end: ' the market rate.',
  },
  stopPriceMustBeAbove: {
    start: 'Stop price must be ',
    emphasized: 'above',
    end: ' the market rate.',
  },
  stopPriceFirstLegMustBeAbove: {
    start: 'Buy Stop Order, Limit price must be ',
    emphasized: 'above',
    end: ' the market rate.',
  },
  stopPriceSecondLegMustBeAbove: {
    start: 'Buy Stop Loss, Limit price must be ',
    emphasized: 'above',
    end: ' the market rate.',
  },
  stopPriceMustBeBelow: {
    start: 'Stop price must be ',
    emphasized: 'below',
    end: ' the market rate.',
  },
  stopPriceFirstLegMustBeBelow: {
    start: 'Sell Stop Order, Limit price must be ',
    emphasized: 'below',
    end: ' the market rate.',
  },
  stopPriceSecondLegMustBeBelow: {
    start: 'Sell Stop Loss, Limit price must be ',
    emphasized: 'below',
    end: ' the market rate.',
  },
};
export function validatePendingPrice(pendingOrderToValidate, selectedSideIsMandatory = true) {
  const orderLeg = pendingOrderToValidate.orderLeg;
  if (!Boolean(pendingOrderToValidate.priceValue)) {
    return {
      isValid: false,
      message: 'priceNotDefined',
    };
  }
  if (selectedSideIsMandatory && !Boolean(pendingOrderToValidate.selectedTradeSide)) {
    return {
      isValid: false,
      message: 'sideNotDefined',
    };
  }
  if (pendingOrderToValidate.priceType === 'limit') {
    if (pendingOrderToValidate.selectedTradeSide === QuoteSideTypeEnum.BUY &&
      pendingOrderToValidate.offerPriceValue < pendingOrderToValidate.priceValue) {
      if (Boolean(orderLeg)) {
        return {
          isValid: false,
          message: `limitPrice${orderLeg}LegMustBeBelow`,
        };
      }
      return {
        isValid: false,
        message: 'limitPriceMustBeBelow',
      };
    }
    if (pendingOrderToValidate.selectedTradeSide === QuoteSideTypeEnum.SELL &&
      pendingOrderToValidate.bidPriceValue > pendingOrderToValidate.priceValue) {
      if (Boolean(orderLeg)) {
        return {
          isValid: false,
          message: `limitPrice${orderLeg}LegMustBeAbove`,
        };
      }
      return {
        isValid: false,
        message: 'limitPriceMustBeAbove',
      };
    }
  }
  if (pendingOrderToValidate.priceType === 'stop') {
    if (pendingOrderToValidate.selectedTradeSide === QuoteSideTypeEnum.BUY &&
      pendingOrderToValidate.offerPriceValue > pendingOrderToValidate.priceValue) {
      if (Boolean(orderLeg)) {
        return {
          isValid: false,
          message: `stopPrice${orderLeg}LegMustBeAbove`,
        };
      }
      return {
        isValid: false,
        message: 'stopPriceMustBeAbove',
      };
    }
    if (pendingOrderToValidate.selectedTradeSide === QuoteSideTypeEnum.SELL &&
      pendingOrderToValidate.bidPriceValue < pendingOrderToValidate.priceValue) {
      if (Boolean(orderLeg)) {
        return {
          isValid: false,
          message: `stopPrice${orderLeg}LegMustBeBelow`,
        };
      }
      return {
        isValid: false,
        message: 'stopPriceMustBeBelow',
      };
    }
  }
  return { isValid: true };
}
export const HARDCODED_FRACTION_SIZE = 4;
export const HARDCODED_EXTRA_DIGITS = 1;
export function getFractionSizeForTriggerPrice(price) {
  return Boolean(price) ? price.FractionSize : HARDCODED_FRACTION_SIZE;
}
export function getExtraDigitsForTriggerPrice(price) {
  return Boolean(price) ? price.ExtraDigits : HARDCODED_EXTRA_DIGITS;
}
export const orderTypeMapper = {
  limit: 'limit',
  stop: 'stop',
};
export function isPendingStrategy(orderType) {
  return [SpotTypesMapper.oco, SpotTypesMapper.ifDone].includes(orderType);
}
//# sourceMappingURL=pending.utils.js.map
